import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export const useManufacturersStore = defineStore('manufacturers', () => {
  const manufacturers = ref([])

  function updateManufacturers(payload) {
    manufacturers.value = payload
  }

  const manufacturersById = computed(() => {
    const map = {}
    for (const m of manufacturers.value) {
      map[m.objId] = m
    }
    return map
  })

  function getManufacturerById(id) {
    return manufacturersById.value[id]
  }

  function getManufacturersByIdList(idList) {
    return idList.map((item) => manufacturersById.value[item.objId]).filter(Boolean)
  }

  return {
    // refs
    manufacturers,
    // computed

    //functions
    updateManufacturers,
    getManufacturerById,
    getManufacturersByIdList,
  }
})
